const JDE_STATUSES = [
  { text: 'Not Initiated', value: 'none' },
  { text: 'Success', value: 'success' },
  { text: 'Failed', value: 'failed' },
];
export default JDE_STATUSES;



// WEBPACK FOOTER //
// ./src/constants/jdeStatuses.js